// src/version.ts
if (typeof window !== "undefined") {
  window.__ORDERLY_VERSION__ = window.__ORDERLY_VERSION__ || {};
  window.__ORDERLY_VERSION__["@orderly.network/types"] = "2.3.2";
}
var version_default = "2.3.2";

// src/constants.ts
var AccountStatusEnum = /* @__PURE__ */ ((AccountStatusEnum2) => {
  AccountStatusEnum2[AccountStatusEnum2["EnableTradingWithoutConnected"] = -1] = "EnableTradingWithoutConnected";
  AccountStatusEnum2[AccountStatusEnum2["NotConnected"] = 0] = "NotConnected";
  AccountStatusEnum2[AccountStatusEnum2["Connected"] = 1] = "Connected";
  AccountStatusEnum2[AccountStatusEnum2["NotSignedIn"] = 2] = "NotSignedIn";
  AccountStatusEnum2[AccountStatusEnum2["SignedIn"] = 3] = "SignedIn";
  AccountStatusEnum2[AccountStatusEnum2["DisabledTrading"] = 4] = "DisabledTrading";
  AccountStatusEnum2[AccountStatusEnum2["EnableTrading"] = 5] = "EnableTrading";
  return AccountStatusEnum2;
})(AccountStatusEnum || {});
var SystemStateEnum = /* @__PURE__ */ ((SystemStateEnum2) => {
  SystemStateEnum2[SystemStateEnum2["Loading"] = 0] = "Loading";
  SystemStateEnum2[SystemStateEnum2["Error"] = 1] = "Error";
  SystemStateEnum2[SystemStateEnum2["Ready"] = 10] = "Ready";
  return SystemStateEnum2;
})(SystemStateEnum || {});
var ExchangeStatusEnum = /* @__PURE__ */ ((ExchangeStatusEnum2) => {
  ExchangeStatusEnum2[ExchangeStatusEnum2["Normal"] = 0] = "Normal";
  ExchangeStatusEnum2[ExchangeStatusEnum2["Maintain"] = 1] = "Maintain";
  return ExchangeStatusEnum2;
})(ExchangeStatusEnum || {});
var NetworkStatusEnum = /* @__PURE__ */ ((NetworkStatusEnum2) => {
  NetworkStatusEnum2[NetworkStatusEnum2["unknown"] = 0] = "unknown";
  NetworkStatusEnum2[NetworkStatusEnum2["unsupported"] = 1] = "unsupported";
  NetworkStatusEnum2[NetworkStatusEnum2["supported"] = 2] = "supported";
  return NetworkStatusEnum2;
})(NetworkStatusEnum || {});
var ARBITRUM_TESTNET_CHAINID = 421614;
var SOLANA_TESTNET_CHAINID = 901901901;
var SOLANA_MAINNET_CHAINID = 900900900;
var STORY_TESTNET_CHAINID = 1516;
var MONAD_TESTNET_CHAINID = 10143;
var ABSTRACT_TESTNET_CHAINID = 11124;
var ABSTRACT_MAINNET_CHAINID = 2741;
var BSC_TESTNET_CHAINID = 97;
var ABSTRACT_CHAIN_ID_MAP = /* @__PURE__ */ new Set([
  ABSTRACT_TESTNET_CHAINID,
  ABSTRACT_MAINNET_CHAINID
]);
var ARBITRUM_TESTNET_CHAINID_HEX = "0x66EEE";
var MANTLE_TESTNET_CHAINID = 5003;
var MANTLE_TESTNET_CHAINID_HEX = "0x138b";
var ARBITRUM_MAINNET_CHAINID = 42161;
var ARBITRUM_MAINNET_CHAINID_HEX = "0xa4b1";
var MEDIA_TABLET = "(max-width: 768px)";
var DEPOSIT_FEE_RATE = 1.05;
var MaxUint256 = BigInt(
  "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
);
var nativeTokenAddress = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
var isNativeTokenChecker = (address) => address === nativeTokenAddress;
var ArbitrumSepoliaChainInfo = {
  name: "Arbitrum Sepolia",
  public_rpc_url: "https://arbitrum-sepolia.gateway.tenderly.co",
  chain_id: "421614",
  currency_symbol: "ETH",
  currency_decimal: 18,
  explorer_base_url: "https://sepolia.arbiscan.io",
  vault_address: "0x0EaC556c0C2321BA25b9DC01e4e3c95aD5CDCd2f"
};
var AbstractTestnetChainInfo = {
  name: "Abstract Testnet",
  public_rpc_url: "https://api.testnet.abs.xyz",
  chain_id: "11124",
  currency_symbol: "ETH",
  currency_decimal: 18,
  explorer_base_url: "https://sepolia.abscan.org",
  vault_address: "0xf14Ff11F3bb1011ff42665Ec869c7827c43745Fd"
};
var AbstractTestnetTokenInfo = {
  chain_id: "11124",
  contract_address: "0xa0BB43E2eA7fcE91F07e628d72fD6333e80F47D2",
  decimals: 6,
  withdrawal_fee: 1,
  cross_chain_withdrawal_fee: 2,
  display_name: "USDC"
};
var SolanaDevnetChainInfo = {
  chain_id: "901901901",
  currency_decimal: 9,
  currency_symbol: "SOL",
  explorer_base_url: "https://explorer.solana.com/?cluster=devnet",
  name: "Solana-Devnet",
  public_rpc_url: "https://api.devnet.solana.com",
  vault_address: "9shwxWDUNhtwkHocsUAmrNAQfBH2DHh4njdAEdHZZkF2"
};
var SolanaDevnetTokenInfo = {
  chain_id: "901901901",
  contract_address: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU",
  decimals: 6,
  withdrawal_fee: 1,
  cross_chain_withdrawal_fee: 5,
  display_name: "USDC"
};
var ArbitrumSepoliaTokenInfo = {
  chain_id: "421614",
  contract_address: "0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d",
  decimals: 6,
  withdrawal_fee: 1,
  cross_chain_withdrawal_fee: 2,
  display_name: "USDC"
};
var TesntTokenFallback = (testnetTokens) => [
  {
    token: "USDC",
    token_hash: "0xd6aca1be9729c13d677335161321649cccae6a591554772516700f986f942eaa",
    decimals: 6,
    minimum_withdraw_amount: 1e-6,
    chain_details: testnetTokens
  }
];

// src/types/api.ts
var AnnouncementType = /* @__PURE__ */ ((AnnouncementType2) => {
  AnnouncementType2["Listing"] = "LISTING";
  AnnouncementType2["Maintenance"] = "MAINTENANCE";
  AnnouncementType2["Delisting"] = "DELISTING";
  return AnnouncementType2;
})(AnnouncementType || {});

// src/order.ts
var OrderType = /* @__PURE__ */ ((OrderType2) => {
  OrderType2["LIMIT"] = "LIMIT";
  OrderType2["MARKET"] = "MARKET";
  OrderType2["IOC"] = "IOC";
  OrderType2["FOK"] = "FOK";
  OrderType2["POST_ONLY"] = "POST_ONLY";
  OrderType2["ASK"] = "ASK";
  OrderType2["BID"] = "BID";
  OrderType2["STOP_LIMIT"] = "STOP_LIMIT";
  OrderType2["STOP_MARKET"] = "STOP_MARKET";
  OrderType2["CLOSE_POSITION"] = "CLOSE_POSITION";
  return OrderType2;
})(OrderType || {});
var BBOOrderType = /* @__PURE__ */ ((BBOOrderType2) => {
  BBOOrderType2["COUNTERPARTY1"] = "counterparty1";
  BBOOrderType2["COUNTERPARTY5"] = "counterparty5";
  BBOOrderType2["QUEUE1"] = "queue1";
  BBOOrderType2["QUEUE5"] = "queue5";
  return BBOOrderType2;
})(BBOOrderType || {});
var OrderLevel = /* @__PURE__ */ ((OrderLevel2) => {
  OrderLevel2[OrderLevel2["ONE"] = 0] = "ONE";
  OrderLevel2[OrderLevel2["TWO"] = 1] = "TWO";
  OrderLevel2[OrderLevel2["THREE"] = 2] = "THREE";
  OrderLevel2[OrderLevel2["FOUR"] = 3] = "FOUR";
  OrderLevel2[OrderLevel2["FIVE"] = 4] = "FIVE";
  return OrderLevel2;
})(OrderLevel || {});
var AlgoOrderRootType = /* @__PURE__ */ ((AlgoOrderRootType2) => {
  AlgoOrderRootType2["TP_SL"] = "TP_SL";
  AlgoOrderRootType2["POSITIONAL_TP_SL"] = "POSITIONAL_TP_SL";
  AlgoOrderRootType2["STOP"] = "STOP";
  AlgoOrderRootType2["BRACKET"] = "BRACKET";
  return AlgoOrderRootType2;
})(AlgoOrderRootType || {});
var TriggerPriceType = /* @__PURE__ */ ((TriggerPriceType2) => {
  TriggerPriceType2["MARK_PRICE"] = "MARK_PRICE";
  return TriggerPriceType2;
})(TriggerPriceType || {});
var AlgoOrderType = /* @__PURE__ */ ((AlgoOrderType2) => {
  AlgoOrderType2["TAKE_PROFIT"] = "TAKE_PROFIT";
  AlgoOrderType2["STOP_LOSS"] = "STOP_LOSS";
  return AlgoOrderType2;
})(AlgoOrderType || {});
var OrderSide = /* @__PURE__ */ ((OrderSide2) => {
  OrderSide2["BUY"] = "BUY";
  OrderSide2["SELL"] = "SELL";
  return OrderSide2;
})(OrderSide || {});
var OrderStatus = /* @__PURE__ */ ((OrderStatus2) => {
  OrderStatus2["OPEN"] = "OPEN";
  OrderStatus2["NEW"] = "NEW";
  OrderStatus2["FILLED"] = "FILLED";
  OrderStatus2["PARTIAL_FILLED"] = "PARTIAL_FILLED";
  OrderStatus2["CANCELLED"] = "CANCELLED";
  OrderStatus2["REPLACED"] = "REPLACED";
  OrderStatus2["COMPLETED"] = "COMPLETED";
  OrderStatus2["INCOMPLETE"] = "INCOMPLETE";
  OrderStatus2["REJECTED"] = "REJECTED";
  return OrderStatus2;
})(OrderStatus || {});

// src/withdraw.ts
var WithdrawStatus = /* @__PURE__ */ ((WithdrawStatus2) => {
  WithdrawStatus2["NotSupported"] = "NotSupported";
  WithdrawStatus2["NotConnected"] = "NotConnected";
  WithdrawStatus2["Unsettle"] = "Unsettle";
  WithdrawStatus2["InsufficientBalance"] = "InsufficientBalance";
  WithdrawStatus2["Normal"] = "Normal";
  return WithdrawStatus2;
})(WithdrawStatus || {});

// src/chains.ts
var Ethereum = {
  chainNameShort: "Ethereum",
  id: 1,
  chainLogo: "",
  chainInfo: {
    chainId: `0x${1 .toString(16)}`,
    chainName: "Ethereum Mainnet",
    nativeCurrency: {
      name: "eth",
      symbol: "ETH",
      decimals: 18,
      fix: 8
    },
    rpcUrls: ["https://mainnet.infura.io/v3/9155d40884554acdb17699a18a1fe348"],
    blockExplorerUrls: ["https://etherscan.io/"]
  },
  minGasBalance: 2e-3,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.025,
  blockExplorerName: "EthScan",
  chainName: "Ethereum Mainnet",
  requestRpc: "https://rpc.ankr.com/eth"
};
var Avalanche = {
  id: 43114,
  chainInfo: {
    chainId: `0x${43114 .toString(16)}`,
    // '0xa86a'
    chainName: "Avalanche",
    nativeCurrency: {
      name: "avax",
      symbol: "AVAX",
      decimals: 18,
      fix: 5
    },
    rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
    blockExplorerUrls: ["https://snowtrace.io/"]
  },
  minGasBalance: 0.05,
  minCrossGasBalance: 0.15,
  maxPrepayCrossGas: 2,
  blockExplorerName: "Snowtrace",
  chainName: "Avalanche",
  chainNameShort: "Avalanche",
  chainLogo: "",
  requestRpc: "https://rpc.ankr.com/avalanche"
};
var Fuji = {
  id: 43113,
  chainInfo: {
    chainId: `0x${43113 .toString(16)}`,
    // '0xa86a'
    chainName: "Avalanche Fuji Testnet",
    nativeCurrency: {
      name: "avax",
      symbol: "AVAX",
      decimals: 18,
      fix: 5
    },
    rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
    blockExplorerUrls: ["https://snowtrace.io/"]
  },
  minGasBalance: 0.05,
  minCrossGasBalance: 0.15,
  maxPrepayCrossGas: 2,
  blockExplorerName: "Snowtrace",
  chainName: "Avalanche Fuji",
  chainNameShort: "Avalanche Fuji",
  chainLogo: "",
  requestRpc: "https://rpc.ankr.com/avalanche"
};
var BNB = {
  id: 56,
  chainInfo: {
    chainId: `0x${56 .toString(16)}`,
    // 0x38
    chainName: "BNB Chain",
    nativeCurrency: {
      name: "bnb",
      symbol: "BNB",
      decimals: 18,
      fix: 6
    },
    rpcUrls: ["https://bsc-dataseed1.binance.org/"],
    blockExplorerUrls: ["https://bscscan.com/"]
  },
  minGasBalance: 0.02,
  minCrossGasBalance: 0.02,
  maxPrepayCrossGas: 0.1,
  blockExplorerName: "BscScan",
  chainName: "Binance Smart Chain",
  chainNameShort: "BNB Chain",
  requestRpc: "https://rpc.ankr.com/bsc",
  chainLogo: ""
};
var Fantom = {
  id: 250,
  chainInfo: {
    chainId: `0x${250 .toString(16)}`,
    // 0x38
    chainName: "Fantom",
    nativeCurrency: {
      name: "ftm",
      symbol: "FTM",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://rpcapi.fantom.network"],
    blockExplorerUrls: ["https://ftmscan.com/"]
  },
  minGasBalance: 1,
  minCrossGasBalance: 10,
  maxPrepayCrossGas: 60,
  blockExplorerName: "FTMScan",
  chainName: "Fantom",
  chainNameShort: "Fantom",
  chainLogo: "",
  requestRpc: "https://rpc.ankr.com/fantom"
};
var Polygon = {
  id: 137,
  chainInfo: {
    chainId: `0x${137 .toString(16)}`,
    chainName: "Polygon",
    nativeCurrency: {
      name: "matic",
      symbol: "MATIC",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://rpc-mainnet.matic.network"],
    blockExplorerUrls: ["https://polygonscan.com/"]
  },
  minGasBalance: 0.1,
  minCrossGasBalance: 1,
  maxPrepayCrossGas: 30,
  blockExplorerName: "Polygonscan",
  chainName: "Polygon",
  chainNameShort: "Polygon",
  requestRpc: "https://rpc.ankr.com/polygon",
  chainLogo: ""
};
var Arbitrum = {
  id: 42161,
  chainInfo: {
    chainId: `0x${42161 .toString(16)}`,
    chainName: "Arbitrum",
    nativeCurrency: {
      name: "eth",
      symbol: "ETH",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://arb1.arbitrum.io/rpc"],
    blockExplorerUrls: ["https://arbiscan.io/"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Arbiscan",
  chainName: "Arbitrum",
  chainNameShort: "Arbitrum",
  requestRpc: "https://arb1.arbitrum.io/rpc",
  chainLogo: ""
};
var Optimism = {
  id: 10,
  chainInfo: {
    chainId: `0x${10 .toString(16)}`,
    chainName: "Optimism",
    nativeCurrency: {
      name: "eth",
      symbol: "ETH",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://mainnet.optimism.io"],
    blockExplorerUrls: ["https://optimistic.etherscan.io/"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Optimism",
  chainName: "Optimism",
  chainNameShort: "Optimism",
  requestRpc: "https://rpc.ankr.com/optimism",
  chainLogo: ""
};
var zkSyncEra = {
  id: 324,
  chainInfo: {
    chainId: `0x${324 .toString(16)}`,
    chainName: "zkSync Era",
    nativeCurrency: {
      name: "eth",
      symbol: "ETH",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://zksync2-mainnet.zksync.io"],
    blockExplorerUrls: ["https://explorer.zksync.io/"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "zkSync Era",
  chainName: "zkSync Era",
  chainNameShort: "zkSync Era",
  requestRpc: "https://zksync2-mainnet.zksync.io/",
  chainLogo: ""
  // blockExplorerName: 'zkSync Era Goerli',
  // chainName: 'zkSync Era Goerli',
  // chainNameShort: 'zkSync Era Goerli',
  // requestRpc: 'https://zksync2-testnet.zksync.dev/',
  // chainLogo:  '',
};
var PolygonzkEVM = {
  id: 1101,
  chainInfo: {
    chainId: `0x${1101 .toString(16)}`,
    chainName: "Polygon zkEVM",
    nativeCurrency: {
      name: "eth",
      symbol: "ETH",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://zkevm-rpc.com"],
    blockExplorerUrls: ["https://zkevm.polygonscan.com/"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Polygon zkEVM",
  chainName: "Polygon zkEVM",
  chainNameShort: "Polygon zkEVM",
  requestRpc: "https://zkevm-rpc.com",
  chainLogo: ""
};
var Linea = {
  id: 59144,
  chainInfo: {
    chainId: `0x${59144 .toString(16)}`,
    chainName: "Linea",
    nativeCurrency: {
      name: "eth",
      symbol: "ETH",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://rpc.linea.build"],
    blockExplorerUrls: ["https://lineascan.build/"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Linea",
  chainName: "Linea",
  chainNameShort: "Linea",
  requestRpc: "https://rpc.linea.build",
  chainLogo: ""
};
var Base = {
  id: 8453,
  chainInfo: {
    chainId: `0x${8453 .toString(16)}`,
    chainName: "Base Network",
    nativeCurrency: {
      name: "eth",
      symbol: "ETH",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://developer-access-mainnet.base.org/"],
    blockExplorerUrls: ["https://basescan.org"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Base",
  chainName: "Base",
  chainNameShort: "Base",
  requestRpc: "https://developer-access-mainnet.base.org/",
  chainLogo: ""
};
var Mantle = {
  id: 5e3,
  chainInfo: {
    chainId: `0x${5e3.toString(16)}`,
    chainName: "Mantle",
    nativeCurrency: {
      name: "MNT",
      symbol: "MNT",
      decimals: 6,
      fix: 4
    },
    rpcUrls: ["https://rpc.mantle.xyz/"],
    blockExplorerUrls: ["https://mantlescan.xyz/"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Mantle",
  chainName: "Mantle",
  chainNameShort: "Mantle",
  requestRpc: "https://rpc.mantle.xyz/",
  chainLogo: ""
};
var ArbitrumGoerli = {
  id: 421613,
  chainInfo: {
    chainId: `0x${421613 .toString(16)}`,
    chainName: "Arbitrum Goerli",
    nativeCurrency: {
      name: "AGOR",
      symbol: "AGOR",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://goerli-rollup.arbitrum.io/rpc"],
    blockExplorerUrls: ["https://goerli-rollup-explorer.arbitrum.io/"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Arbitrum Goerli",
  chainName: "Arbitrum Goerli",
  chainNameShort: "Arbitrum Goerli",
  requestRpc: "https://goerli-rollup.arbitrum.io/rpc",
  chainLogo: ""
};
var ArbitrumSepolia = {
  id: 421614,
  chainInfo: {
    chainId: `0x${421614 .toString(16)}`,
    chainName: "Arbitrum Sepolia",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://arbitrum-sepolia.blockpi.network/v1/rpc/public"],
    blockExplorerUrls: ["https://sepolia-explorer.arbitrum.io"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Arbitrum Sepolia",
  chainName: "Arbitrum Sepolia",
  chainNameShort: "Arbitrum Sepolia",
  requestRpc: "https://arbitrum-sepolia.blockpi.network/v1/rpc/public",
  chainLogo: ""
};
var OptimismGoerli = {
  id: 420,
  chainInfo: {
    chainId: `0x${420 .toString(16)}`,
    chainName: "Optimism Goerli",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://optimism-goerli.gateway.tenderly.co"],
    blockExplorerUrls: ["https://goerli-optimism.etherscan.io"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Optimism Goerli",
  chainName: "Optimism Goerli",
  chainNameShort: "Optimism Goerli",
  requestRpc: "https://optimism-goerli.gateway.tenderly.co",
  chainLogo: ""
};
var OptimismSepolia = {
  id: 11155420,
  chainInfo: {
    chainId: `0x${11155420 .toString(16)}`,
    chainName: "Optimism Sepolia",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://sepolia.optimism.io"],
    blockExplorerUrls: ["https://sepolia-optimistic.etherscan.io"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Optimism Sepolia",
  chainName: "Optimism Sepolia",
  chainNameShort: "Optimism Sepolia",
  requestRpc: "https://sepolia.optimism.io",
  chainLogo: ""
};
var BaseSepolia = {
  id: 84532,
  chainInfo: {
    chainId: `0x${84532 .toString(16)}`,
    chainName: "Base Sepolia",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://base-sepolia-rpc.publicnode.com"],
    blockExplorerUrls: ["https://base-sepolia.blockscout.com/"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Base Sepolia",
  chainName: "Base Sepolia",
  chainNameShort: "Base Sepolia",
  requestRpc: "https://base-sepolia-rpc.publicnode.com",
  chainLogo: ""
};
var MantleSepolia = {
  id: 5003,
  chainInfo: {
    chainId: `0x${5003 .toString(16)}`,
    chainName: "Mantle Sepolia",
    nativeCurrency: {
      name: "MNT",
      symbol: "MNT",
      decimals: 6,
      fix: 4
    },
    rpcUrls: ["https://rpc.sepolia.mantle.xyz/"],
    blockExplorerUrls: ["https://sepolia.mantlescan.xyz/"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Mantle Sepolia",
  chainName: "Mantle Sepolia",
  chainNameShort: "Mantle Sepolia",
  requestRpc: "https://rpc.sepolia.mantle.xyz/",
  chainLogo: ""
};
var PolygonAmoy = {
  id: 80002,
  chainInfo: {
    chainId: `0x${80002 .toString(16)}`,
    chainName: "Polygon Amoy",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 6,
      fix: 4
    },
    rpcUrls: ["https://rpc-amoy.polygon.technology/"],
    blockExplorerUrls: ["https://www.oklink.com/amoy"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "Polygon Amoy",
  chainName: "Polygon Amoy",
  chainNameShort: "Polygon Amoy",
  requestRpc: "https://rpc-amoy.polygon.technology/",
  chainLogo: ""
};
var Sei = {
  id: 1329,
  chainInfo: {
    chainId: `0x${1329 .toString(16)}`,
    chainName: "Sei Network",
    nativeCurrency: {
      name: "SEI",
      symbol: "SEI",
      decimals: 18,
      fix: 4
    },
    rpcUrls: ["https://evm-rpc.sei-apis.com"],
    blockExplorerUrls: ["https://seitrace.com/"]
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "SEI",
  chainName: "Sei Network",
  chainNameShort: "SEI",
  requestRpc: "https://evm-rpc.sei-apis.com",
  chainLogo: ""
};
var StoryTestnet = {
  name: "Story Odyssey Testnet",
  public_rpc_url: "https://rpc.odyssey.storyrpc.io/",
  chain_id: 1516,
  currency_symbol: "IP",
  explorer_base_url: "",
  vault_address: ""
};
var StoryOdysseyTestnet = {
  id: 1329,
  chainInfo: {
    chainId: `0x${StoryTestnet.chain_id.toString(16)}`,
    chainName: StoryTestnet.name,
    nativeCurrency: {
      name: "IP",
      symbol: "IP",
      decimals: 18,
      fix: 4
    },
    rpcUrls: [StoryTestnet.public_rpc_url],
    blockExplorerUrls: []
  },
  minGasBalance: 2e-4,
  minCrossGasBalance: 2e-3,
  maxPrepayCrossGas: 0.03,
  blockExplorerName: "SEI",
  chainName: "Sei Network",
  chainNameShort: "SEI",
  requestRpc: "https://evm-rpc.sei-apis.com",
  chainLogo: ""
};
var chainsInfoMap = /* @__PURE__ */ new Map([
  [Ethereum.id, Ethereum],
  [Avalanche.id, Avalanche],
  [Fuji.id, Fuji],
  [BNB.id, BNB],
  [Fantom.id, Fantom],
  [Polygon.id, Polygon],
  [Arbitrum.id, Arbitrum],
  [Optimism.id, Optimism],
  [zkSyncEra.id, zkSyncEra],
  [PolygonzkEVM.id, PolygonzkEVM],
  [Linea.id, Linea],
  [Base.id, Base],
  [Mantle.id, Mantle],
  [ArbitrumGoerli.id, ArbitrumGoerli],
  [ArbitrumSepolia.id, ArbitrumSepolia],
  [OptimismGoerli.id, OptimismGoerli],
  [OptimismSepolia.id, OptimismSepolia],
  [BaseSepolia.id, BaseSepolia],
  [MantleSepolia.id, MantleSepolia],
  [PolygonAmoy.id, PolygonAmoy],
  [Sei.id, Sei],
  [StoryOdysseyTestnet.id, StoryOdysseyTestnet]
]);
var SolanaDevnet = {
  id: 901901901,
  chainInfo: {
    name: "Solana Devnet",
    public_rpc_url: "",
    chainId: 901901901,
    currency_symbol: "SOL",
    explorer_base_url: "",
    vault_address: ""
  }
};
var TestnetChains = [
  {
    network_infos: {
      name: "Arbitrum Sepolia",
      shortName: "Arbitrum Sepolia",
      public_rpc_url: "https://arbitrum-sepolia.blockpi.network/v1/rpc/public",
      chain_id: 421614,
      currency_symbol: "ETH",
      bridge_enable: true,
      mainnet: false,
      explorer_base_url: "https://sepolia.arbiscan.io",
      est_txn_mins: null
    },
    token_infos: [
      {
        symbol: "USDC",
        address: "0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d",
        decimals: 6
      }
    ]
  },
  {
    network_infos: {
      name: "Solana Devnet",
      public_rpc_url: "",
      chain_id: 901901901,
      currency_symbol: "SOL",
      explorer_base_url: "",
      vault_address: ""
    },
    token_infos: [
      {
        symbol: "USDC",
        address: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU",
        decimals: 6
      }
    ]
  },
  {
    network_infos: StoryTestnet,
    token_infos: [
      {
        symbol: "USDC",
        address: "0xF1815bd50389c46847f0Bda824eC8da914045D14",
        decimals: 6
      }
    ]
  }
  // {
  //   network_infos: {
  //     name: "Mantle Sepolia",
  //     shortName: "Mantle Sepolia",
  //     public_rpc_url: "https://rpc.sepolia.mantle.xyz/",
  //     chain_id: 5003,
  //     currency_symbol: "MNT",
  //     bridge_enable: true,
  //     mainnet: false,
  //     explorer_base_url: "https://sepolia.mantlescan.xyz/",
  //     est_txn_mins: null,
  //   },
  //   token_infos: [
  //     {
  //       symbol: "USDC",
  //       address: "0xAcab8129E2cE587fD203FD770ec9ECAFA2C88080",
  //       decimals: 6,
  //       display_name: "USDC.e",
  //     },
  //   ],
  // },
  // {
  //   network_infos: {
  //     name: "Arbitrum Goerli",
  //     shortName: "Arbitrum Goerli",
  //     public_rpc_url: "https://goerli-rollup.arbitrum.io/rpc",
  //     chain_id: 421613,
  //     currency_symbol: "ETH",
  //     bridge_enable: true,
  //     mainnet: false,
  //     explorer_base_url: "https://goerli.arbiscan.io/",
  //     est_txn_mins: null,
  //   },
  //   token_infos: [
  //     {
  //       symbol: "USDC",
  //       address: "0xfd064A18f3BF249cf1f87FC203E90D8f650f2d63",
  //       decimals: 6,
  //     },
  //   ],
  // },
  // {
  //   network_infos: {
  //     name: "Optimism Goerli",
  //     shortName: "Optimism Goerli",
  //     public_rpc_url: "https://optimism-goerli.gateway.tenderly.co",
  //     chain_id: 420,
  //     currency_symbol: "ETH",
  //     bridge_enable: true,
  //     mainnet: false,
  //     explorer_base_url: "https://goerli-optimism.etherscan.io",
  //     est_txn_mins: null,
  //   },
  // },
];
var defaultMainnetChains = [Arbitrum, Base, Optimism];
var defaultTestnetChains = [ArbitrumSepolia];
var ChainNamespace = /* @__PURE__ */ ((ChainNamespace2) => {
  ChainNamespace2["evm"] = "EVM";
  ChainNamespace2["solana"] = "SOL";
  return ChainNamespace2;
})(ChainNamespace || {});
var AbstractChains = /* @__PURE__ */ new Set([2741, 11124]);
var SolanaChains = /* @__PURE__ */ new Set([901901901, 900900900]);

// src/track.ts
var TrackerEventName = /* @__PURE__ */ ((TrackerEventName2) => {
  TrackerEventName2["trackIdentifyUserId"] = "track_identify_user_id";
  TrackerEventName2["trackIdentify"] = "track_identify";
  TrackerEventName2["trackCustomEvent"] = "track_custom_event";
  TrackerEventName2["withdrawSuccess"] = "withdraw_request_success";
  TrackerEventName2["withdrawFailed"] = "withdraw_request_failure";
  TrackerEventName2["depositSuccess"] = "deposit_request_success";
  TrackerEventName2["depositFailed"] = "deposit_request_failure";
  TrackerEventName2["signinSuccess"] = "sign_message_success";
  TrackerEventName2["placeOrderSuccess"] = "place_order_success";
  TrackerEventName2["walletConnect"] = "connect_wallet_success";
  TrackerEventName2["clickLinkDeviceButton"] = "click_link_device_button";
  TrackerEventName2["signLinkDeviceMessageSuccess"] = "sign_link_device_message_success";
  TrackerEventName2["linkDeviceModalClickConfirm"] = "link_device_modal_click_confirm";
  TrackerEventName2["socialLoginSuccess"] = "social_login_success";
  TrackerEventName2["clickSwitchNetwork"] = "click_switch_network";
  TrackerEventName2["clickSwitchWallet"] = "click_switch_wallet";
  TrackerEventName2["switchNetworkSuccess"] = "switch_network_success";
  TrackerEventName2["clickExportPrivateKey"] = "click_export_private_key";
  TrackerEventName2["switchLanguage"] = "switch_language";
  TrackerEventName2["leaderboardCampaignClickTradeNow"] = "leaderboard_campaign_click_trade_now";
  TrackerEventName2["leaderboardCampaignClickLearnMore"] = "leaderboard_campaign_click_learn_more";
  return TrackerEventName2;
})(TrackerEventName || {});

// src/wallet.ts
var WS_WalletStatusEnum = /* @__PURE__ */ ((WS_WalletStatusEnum2) => {
  WS_WalletStatusEnum2["NO"] = "NO";
  WS_WalletStatusEnum2["FAILED"] = "FAILED";
  WS_WalletStatusEnum2["PENDING"] = "PENDING";
  WS_WalletStatusEnum2["PROCESSING"] = "PROCESSING";
  WS_WalletStatusEnum2["COMPLETED"] = "COMPLETED";
  return WS_WalletStatusEnum2;
})(WS_WalletStatusEnum || {});

// src/storageKey.ts
var LedgerWalletKey = "orderly:ledger-wallet";
var ConnectorKey = "orderly:connectorKey";
var ChainKey = "order:chain";
var LinkDeviceKey = "orderly_link_device";

// src/errors.ts
var ApiError = class extends Error {
  constructor(message, code) {
    super(message);
    this.code = code;
    this.name = "ApiError";
  }
};
var SDKError = class extends Error {
  constructor(message) {
    super(`[ORDERLY SDK ERROR]:${message}`);
    this.name = "SDKError";
  }
};

// src/sign.ts
var definedTypes = {
  EIP712Domain: [
    { name: "name", type: "string" },
    { name: "version", type: "string" },
    { name: "chainId", type: "uint256" },
    { name: "verifyingContract", type: "address" }
  ],
  Registration: [
    { name: "brokerId", type: "string" },
    { name: "chainId", type: "uint256" },
    { name: "timestamp", type: "uint64" },
    { name: "registrationNonce", type: "uint256" }
  ],
  Withdraw: [
    { name: "brokerId", type: "string" },
    { name: "chainId", type: "uint256" },
    { name: "receiver", type: "address" },
    { name: "token", type: "string" },
    { name: "amount", type: "uint256" },
    { name: "withdrawNonce", type: "uint64" },
    { name: "timestamp", type: "uint64" }
  ],
  AddOrderlyKey: [
    { name: "brokerId", type: "string" },
    { name: "chainId", type: "uint256" },
    { name: "orderlyKey", type: "string" },
    { name: "scope", type: "string" },
    { name: "timestamp", type: "uint64" },
    { name: "expiration", type: "uint64" }
  ],
  SettlePnl: [
    { name: "brokerId", type: "string" },
    { name: "chainId", type: "uint256" },
    { name: "settleNonce", type: "uint64" },
    { name: "timestamp", type: "uint64" }
  ]
};

// src/index.ts
import * as superstruct from "superstruct";

// src/assetHistory.ts
var AssetHistoryStatusEnum = /* @__PURE__ */ ((AssetHistoryStatusEnum2) => {
  AssetHistoryStatusEnum2["NEW"] = "NEW";
  AssetHistoryStatusEnum2["CONFIRM"] = "CONFIRM";
  AssetHistoryStatusEnum2["PROCESSING"] = "PROCESSING";
  AssetHistoryStatusEnum2["COMPLETED"] = "COMPLETED";
  AssetHistoryStatusEnum2["FAILED"] = "FAILED";
  AssetHistoryStatusEnum2["PENDING_REBALANCE"] = "PENDING_REBALANCE";
  return AssetHistoryStatusEnum2;
})(AssetHistoryStatusEnum || {});
export {
  ABSTRACT_CHAIN_ID_MAP,
  ABSTRACT_MAINNET_CHAINID,
  ABSTRACT_TESTNET_CHAINID,
  ARBITRUM_MAINNET_CHAINID,
  ARBITRUM_MAINNET_CHAINID_HEX,
  ARBITRUM_TESTNET_CHAINID,
  ARBITRUM_TESTNET_CHAINID_HEX,
  AbstractChains,
  AbstractTestnetChainInfo,
  AbstractTestnetTokenInfo,
  AccountStatusEnum,
  AlgoOrderRootType,
  AlgoOrderType,
  AnnouncementType,
  ApiError,
  Arbitrum,
  ArbitrumGoerli,
  ArbitrumSepolia,
  ArbitrumSepoliaChainInfo,
  ArbitrumSepoliaTokenInfo,
  AssetHistoryStatusEnum,
  Avalanche,
  BBOOrderType,
  BNB,
  BSC_TESTNET_CHAINID,
  Base,
  BaseSepolia,
  ChainKey,
  ChainNamespace,
  ConnectorKey,
  DEPOSIT_FEE_RATE,
  Ethereum,
  ExchangeStatusEnum,
  Fantom,
  Fuji,
  LedgerWalletKey,
  Linea,
  LinkDeviceKey,
  MANTLE_TESTNET_CHAINID,
  MANTLE_TESTNET_CHAINID_HEX,
  MEDIA_TABLET,
  MONAD_TESTNET_CHAINID,
  Mantle,
  MantleSepolia,
  MaxUint256,
  NetworkStatusEnum,
  Optimism,
  OptimismGoerli,
  OptimismSepolia,
  OrderLevel,
  OrderSide,
  OrderStatus,
  OrderType,
  Polygon,
  PolygonAmoy,
  PolygonzkEVM,
  SDKError,
  SOLANA_MAINNET_CHAINID,
  SOLANA_TESTNET_CHAINID,
  STORY_TESTNET_CHAINID,
  Sei,
  SolanaChains,
  SolanaDevnet,
  SolanaDevnetChainInfo,
  SolanaDevnetTokenInfo,
  StoryOdysseyTestnet,
  StoryTestnet,
  SystemStateEnum,
  TesntTokenFallback,
  TestnetChains,
  TrackerEventName,
  TriggerPriceType,
  WS_WalletStatusEnum,
  WithdrawStatus,
  chainsInfoMap,
  defaultMainnetChains,
  defaultTestnetChains,
  definedTypes,
  isNativeTokenChecker,
  nativeTokenAddress,
  superstruct,
  version_default as version,
  zkSyncEra
};
//# sourceMappingURL=index.mjs.map